import { VisitorBanEntryType } from 'common/enums/visitor-ban-entry-type.enum';

export const visitorBanEntryTypeMap: Record<VisitorBanEntryType, string> = {
  [VisitorBanEntryType.Undefined]: 'Unidentified',
  [VisitorBanEntryType.Person]: 'Person',
  [VisitorBanEntryType.Company]: 'Company',
  [VisitorBanEntryType.Vehicle]: 'Vehicle',
};

export const visitorBanEntryTypeColorMap: Record<VisitorBanEntryType, string> = {
  [VisitorBanEntryType.Undefined]: '#C1FFEA',
  [VisitorBanEntryType.Person]: '#C1FFEA',
  [VisitorBanEntryType.Company]: '#C1FFEA',
  [VisitorBanEntryType.Vehicle]: '#C1FFEA',
};

export const visitorBanEntryTypeOptions = [
  { value: VisitorBanEntryType.Person, label: 'Person' },
  { value: VisitorBanEntryType.Company, label: 'Company' },
  { value: VisitorBanEntryType.Vehicle, label: 'Vehicle' },
];
